<template>
    <div>
        <div class="modal fade" tabindex="-1" id="ModalProcessoProgressao" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content calendar-modal position-relative">
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 z-3"
                            data-bs-dismiss="modal" aria-label="Fechar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-body p-0">
                        <!-- Header -->
                        <div class="day-details-header border-0 pb-3">
                            <div class="d-flex align-items-center gap-3">
                                <div class="calendar-icon-wrapper" :class="wrapperClass" :title="tituloFiltro">
                                    <!-- Assinatura -->
                                    <svg v-if="iconType==='ASSINATURA'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z" />
                                    </svg>

                                    <!-- Aprovação -->
                                    <svg v-else-if="iconType==='APROVACAO'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z" />
                                    </svg>

                                    <!-- Revisão -->
                                    <svg v-else-if="iconType==='REVISAO'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z" />
                                    </svg>
                                </div>
                                <div class="flex-grow-1">
                                    <h5 class="modal-title mb-0 fw-bold">
                                        {{ tituloFiltro }} pendentes
                                    </h5>
                                    <p class="text-muted small mb-0 mt-1">
                                        {{ itens.length }} {{ itens.length === 1 ? 'item' : 'itens' }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Corpo -->
                        <div class="day-details-body pt-0">
                            <!-- Loading -->
                            <div v-if="loading" class="skeleton-list">
                                <div class="skeleton-card" v-for="i in 4" :key="i"></div>
                            </div>

                            <!-- Vazio -->
                            <div v-else-if="!itens || itens.length === 0" class="empty-state text-center py-5">
                                <div class="empty-icon mb-3">
                                    <i class="far fa-calendar-check"></i>
                                </div>
                                <h6 class="text-muted mb-2">Nenhum item pendente</h6>
                                <p class="text-muted small mb-0">Não há artefatos aguardando ação nesse filtro.</p>
                            </div>

                            <!-- Lista -->
                            <div v-else class="events-list">
                                <button v-for="(row, idx) in itens"
                                        :key="idx"
                                        type="button"
                                        class="event-card mt-1"
                                        :class="pillStateClass(row)"
                                        @click="abrirArtefato(row)">
                                    <div class="event-card-indicator"></div>
                                    <div class="event-card-content">
                                        <div class="event-card-header d-flex align-items-start justify-content-between gap-3 mb-2">
                                            <div class="d-flex align-items-start gap-3 flex-grow-1 min-w-0">
                                                <div class="event-icon">
                                                    <i class="far fa-file-alt"></i>
                                                </div>
                                                <div class="flex-grow-1 min-w-0">
                                                    <h6 class="event-title mb-1">
                                                        {{ row.nmModelo }}
                                                    </h6>
                                                    <div class="event-badge" v-if="dataLimite(row)">
                                                        <i class="far fa-clock me-1"></i>
                                                        {{ formatDate(row.dtLimite) }}
                                                        <span class="ms-2 text-muted">• {{ labelPrazo(row) }}</span>
                                                    </div>
                                                    <div class="event-badge" v-else>
                                                        <i class="far fa-clock me-1"></i>
                                                        --/--/----
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="event-status-badge" :class="statusBadgeClass(row)">
                                                <i class="fas fa-flag me-1"></i>
                                                {{ row.nmTipoStatusHistorico }}
                                            </div>
                                        </div>

                                        <div class="event-card-body">
                                            <div class="event-info-row">
                                                <i class="far fa-folder-open me-2"></i>
                                                <span class="event-info-label">Processo:</span>
                                                <span class="event-info-value">{{ row.dsNome }}</span>
                                            </div>
                                        </div>

                                        <div class="event-card-footer mt-2">
                                            <span class="view-link">
                                                Ver detalhes
                                                <i class="fas fa-arrow-right ms-1"></i>
                                            </span>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div> <!-- modal-content -->
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalProcessoProgressao',
        props: {
            FiltroEtapa: { type: String, default: 'TODOS' }, // 'REVISAO' | 'APROVACAO' | 'ASSINATURA' | 'TODOS'
        },
        data() {
            return {
                modalInstance: null,
                internoFiltro: this.FiltroEtapa,
                loading: false,
                itens: [],
            }
        },
        watch: {
            FiltroEtapa() {
                this.internoFiltro = this.FiltroEtapa
                if (this.isOpen()) this.getProcessosParaProgresso()
            }
        },
        computed: {
            tituloFiltro() {
                const f = (this.internoFiltro || '').toUpperCase()
                if (f === 'REVISAO') return 'Revisões'
                if (f === 'APROVACAO') return 'Aprovações'
                if (f === 'ASSINATURA') return 'Assinaturas'
                return 'Itens'
            },
            iconType() {
                const f = (this.internoFiltro || '').toUpperCase();
                if (f === 'ASSINATURA' || f === 'APROVACAO' || f === 'REVISAO') return f;
                return 'TODOS';
            },
            wrapperClass() {
                if (this.iconType === 'ASSINATURA') return 'is-assinatura';
                if (this.iconType === 'APROVACAO') return 'is-aprovacao';
                if (this.iconType === 'REVISAO') return 'is-revisao';
                return '';
            },
        },
        methods: {
            isOpen() {
                const el = document.getElementById('ModalProcessoProgressao')
                return !!el && el.classList.contains('show')
            },

            abrir(filtro) {
                if (filtro) {
                    this.internoFiltro = filtro
                    this.$emit('update:FiltroEtapa', filtro)
                }
                if (!this.modalInstance) {
                    this.modalInstance = new window.bootstrap.Modal('#ModalProcessoProgressao', { focus: false })
                }
                this.modalInstance.show()
                this.load()
            },

            load() {
                this.getProcessosParaProgresso()
            },

            async getProcessosParaProgresso() {
                let $this = this;
                $this.loading = true
                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoArtefato/GetModelosParaProgresso`, {
                        params: { FiltroEtapa: $this.internoFiltro },
                    })
                    if (data?.success) {
                        $this.itens = data.data || []
                    } else {
                        console.warn('Resposta sem sucesso')
                        $this.itens = []
                    }
                } catch (err) {
                    console.error('Erro ao fazer requisição:', err)
                    avisoToast('Erro ao carregar processos!', 'warning')
                    $this.itens = []
                } finally {
                    $this.loading = false
                }
            },

            // Retorna a data apenas quando ela é utilizável; a API envia 0001-01-01 quando não há prazo
            dataLimite(row) {
                const valor = row?.dtLimite
                if (!valor) return null
                const d = new Date(valor)
                if (isNaN(d.getTime()) || d.getFullYear() <= 1900) return null
                return d
            },

            formatDate(dt) {
                const d = new Date(dt)
                if (isNaN(d.getTime())) return '--/--/----'
                return d.toLocaleDateString('pt-BR')
            },

            pillStateClass(row) {
                const due = this.dataLimite(row)
                if (!due) return ''
                const today = new Date(); today.setHours(0, 0, 0, 0)
                const d = new Date(due); d.setHours(0, 0, 0, 0)
                if (d < today) return 'is-danger'
                const in7 = new Date(today); in7.setDate(in7.getDate() + 7)
                if (d <= in7) return 'is-warning'
                return ''
            },

            statusBadgeClass(row) {
                const c = this.pillStateClass(row)
                if (c === 'is-danger') return 'danger'
                if (c === 'is-warning') return 'warning'
                return ''
            },

            labelPrazo(row) {
                const due = this.dataLimite(row)
                if (!due) return ''
                const today = new Date(); today.setHours(0, 0, 0, 0)
                const d = new Date(due); d.setHours(0, 0, 0, 0)
                const diffDays = Math.round((d - today) / (1000 * 60 * 60 * 24))

                if (diffDays < 0) return `atrasado há ${Math.abs(diffDays)} dia${Math.abs(diffDays) === 1 ? '' : 's'}`
                if (diffDays === 0) return 'vence hoje'
                if (diffDays === 1) return 'em 1 dia'
                return `em ${diffDays} dias`
            },

            etapaDaLinha(row) {
                const f = (this.internoFiltro || '').toUpperCase()
                if (f === 'REVISAO' || f === 'APROVACAO' || f === 'ASSINATURA') return f

                const id = Number(row?.idTipoStatusHistorico)
                if (id === 4) return 'REVISAO'
                if (id === 6) return 'APROVACAO'
                if (id === 8) return 'ASSINATURA'

                const nome = (row?.nmTipoStatusHistorico || '').toUpperCase()
                if (nome.includes('REVIS')) return 'REVISAO'
                if (nome.includes('APROVA')) return 'APROVACAO'
                if (nome.includes('ASSIN')) return 'ASSINATURA'

                return null
            },

            async abrirArtefato(row) {
                const idProcArt = row.idProcessoArtefato
                if (!idProcArt) {
                    console.warn('idProcessoArtefato ausente na linha:', row)
                    return
                }

                const etapa = this.etapaDaLinha(row)
                if (!etapa) {
                    console.warn('Etapa não reconhecida para a linha:', row)
                    return
                }
                this.modalInstance?.hide();

                setTimeout(() => {
                    if (etapa === 'ASSINATURA') {
                        this.$router.push({
                            name: 'ProcessoAssinatura',
                            params: { id: String(idProcArt) },
                        })
                    } else if (etapa === 'APROVACAO') {
                        this.$router.push({
                            name: 'ProcessoAprovacao',
                            params: { id: String(idProcArt) },
                        })
                    } else {
                        this.$router.push({
                            name: 'ProcessoRevisao',
                            params: { id: String(idProcArt) },
                        })
                    }
                }, 150)
            },
        },

        mounted() {
            this.modalInstance = new window.bootstrap.Modal('#ModalProcessoProgressao', { focus: false })
            const el = document.getElementById('ModalProcessoProgressao')
            el.addEventListener('shown.bs.modal', () => this.load())
        },
    }
</script>

<style lang="scss" scoped>
    .modal-xl {
        width: 90%;
        max-width: 1100px;
        margin: 0 auto;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .calendar-modal {
        background: #fff;
        border: 0;
        border-radius: .75rem;
        padding: 0;
        overflow: visible;
    }

    .day-details-header {
        background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
        padding: 1.25rem 1.5rem;
        color: white;

        .calendar-icon-wrapper {
            width: 48px;
            height: 48px;
            background: rgba(255,255,255,.2);
            border-radius: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
            backdrop-filter: blur(10px);
            box-shadow: 0 4px 12px rgba(0,0,0,.1);
        }

        .modal-title {
            color: white;
        }
    }

    .day-details-body {
        padding: 1.25rem 1.5rem 1.5rem;
        background: #f8f9fa;
        max-height: 70vh;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #e9ecef;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: #adb5bd;
            border-radius: 10px;

            &:hover {
                background: #6c757d;
            }
        }
    }



    .events-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .event-card {
        position: relative;
        display: block;
        width: 100%;
        background: white;
        border: none;
        border-radius: 1rem;
        padding: 0;
        text-align: left;
        overflow: hidden;
        transition: all .3s ease;
        box-shadow: 0 2px 8px rgba(0,0,0,.08);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0,0,0,.15);

            .view-link {
                color: #667eea;
                transform: translateX(4px);
            }

            .event-card-indicator {
                width: 6px;
            }
        }
    }

    .event-card-indicator {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: #0d6efd;
        transition: width .3s ease;
    }

    .event-card.is-success .event-card-indicator {
        background: linear-gradient(180deg, #10b981 0%, #059669 100%);
    }

    .event-card.is-warning .event-card-indicator {
        background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
    }

    .event-card.is-danger .event-card-indicator {
        background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
    }

    .event-card-content {
        padding: 1.1rem 1.25rem 1.1rem 1.5rem;
    }

    .event-icon {
        width: 40px;
        height: 40px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: .75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 1.1rem;
        flex-shrink: 0;
        box-shadow: 0 4px 12px rgba(102,126,234,.3);
    }

    .event-card.is-success .event-icon {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 4px 12px rgba(16,185,129,.3);
    }

    .event-card.is-warning .event-icon {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 0 4px 12px rgba(245,158,11,.3);
    }

    .event-card.is-danger .event-icon {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 0 4px 12px rgba(239,68,68,.3);
    }

    .event-title {
        font-size: 1rem;
        font-weight: 600;
        color: #1f2937;
        margin: 0;
    }

    .event-badge {
        display: inline-flex;
        align-items: center;
        font-size: .8rem;
        color: #6b7280;
        background: #f3f4f6;
        padding: .25rem .65rem;
        border-radius: .5rem;
        font-weight: 500;
    }

    .event-status-badge {
        display: inline-flex;
        align-items: center;
        font-size: .75rem;
        font-weight: 600;
        padding: .4rem .75rem;
        border-radius: .5rem;
        background: #d1e7dd;
        color: #0f5132;
        white-space: nowrap;

        &.warning {
            background: #fff3cd;
            color: #856404;
        }

        &.danger {
            background: #f8d7da;
            color: #842029;
        }
    }

    .event-card-body {
        margin-top: .5rem;
    }

    .event-info-row {
        display: flex;
        align-items: flex-start;
        gap: .5rem;
        font-size: .9rem;
        color: #4b5563;
        line-height: 1.5;

        i {
            color: #9ca3af;
            margin-top: .15rem;
            flex-shrink: 0;
        }
    }

    .event-info-label {
        font-weight: 600;
        color: #6b7280;
        flex-shrink: 0;
    }

    .event-info-value {
        color: #374151;
        word-break: break-word;
    }

    .event-card-footer {
        padding-top: .6rem;
        border-top: 1px solid #f3f4f6;
    }

    .view-link {
        font-size: .875rem;
        font-weight: 600;
        color: #6b7280;
        transition: all .3s ease;
        display: inline-flex;
        align-items: center;

        i {
            font-size: .75rem;
            transition: transform .3s ease;
        }
    }
    /* Loading skeleton */
    .skeleton-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .skeleton-card {
        height: 82px;
        border-radius: 1rem;
        background: linear-gradient(90deg, #f5f7fb 0%, #eef2f7 50%, #f5f7fb 100%);
        animation: shimmer 1.4s infinite linear;
    }

    @keyframes shimmer {
        0% {
            background-position: 0 0
        }

        100% {
            background-position: 100% 0
        }
    }

    .empty-state .empty-icon {
        font-size: 3rem;
        color: #dee2e6;
    }

    /* ============================================
       DARK THEME - Modern & Beautiful
       ============================================ */

    /* Modal Container */
    [data-bs-theme="dark"] .calendar-modal {
        background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
    }

    /* Header */
    [data-bs-theme="dark"] .day-details-header {
        background: linear-gradient(135deg, #1e40af 0%, #0891b2 100%);
    }

    [data-bs-theme="dark"] .day-details-header .calendar-icon-wrapper {
        background: rgba(255, 255, 255, 0.15);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme="dark"] .day-details-header .modal-title {
        color: #ffffff;
    }

    [data-bs-theme="dark"] .day-details-header .text-muted {
        color: rgba(255, 255, 255, 0.9) !important;
    }

    /* Body */
    [data-bs-theme="dark"] .day-details-body {
        background: #1a1d29;
    }

    [data-bs-theme="dark"] .day-details-body::-webkit-scrollbar-track {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .day-details-body::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
    }

    [data-bs-theme="dark"] .day-details-body::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);
    }

    /* Event Cards */
    [data-bs-theme="dark"] .event-card {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }

    [data-bs-theme="dark"] .event-card:hover {
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
        border-color: rgba(59, 130, 246, 0.2);
    }

    [data-bs-theme="dark"] .event-card:hover .view-link {
        color: #60a5fa;
    }

    /* Event Card Indicator */
    [data-bs-theme="dark"] .event-card-indicator {
        background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
    }

    [data-bs-theme="dark"] .event-card.is-success .event-card-indicator {
        background: linear-gradient(180deg, #10b981 0%, #059669 100%);
    }

    [data-bs-theme="dark"] .event-card.is-warning .event-card-indicator {
        background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
    }

    [data-bs-theme="dark"] .event-card.is-danger .event-card-indicator {
        background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
    }

    /* Event Icon */
    [data-bs-theme="dark"] .event-icon {
        background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
        box-shadow: 0 4px 16px rgba(79, 70, 229, 0.4);
    }

    [data-bs-theme="dark"] .event-card.is-success .event-icon {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4);
    }

    [data-bs-theme="dark"] .event-card.is-warning .event-icon {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4);
    }

    [data-bs-theme="dark"] .event-card.is-danger .event-icon {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);
    }

    /* Event Content */
    [data-bs-theme="dark"] .event-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .event-badge {
        background: linear-gradient(135deg, #1a1f2e 0%, #232938 100%);
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .event-badge .text-muted {
        color: #9ca3af !important;
    }

    /* Event Status Badge */
    [data-bs-theme="dark"] .event-status-badge {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
        color: #6ee7b7;
    }

    [data-bs-theme="dark"] .event-status-badge.warning {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        color: #fcd34d;
    }

    [data-bs-theme="dark"] .event-status-badge.danger {
        background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
        color: #fca5a5;
    }

    /* Event Info */
    [data-bs-theme="dark"] .event-info-row {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .event-info-row i {
        color: #6b7280;
    }

    [data-bs-theme="dark"] .event-info-label {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .event-info-value {
        color: #e5e7eb;
    }

    /* Event Footer */
    [data-bs-theme="dark"] .event-card-footer {
        border-top-color: rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .view-link {
        color: #9ca3af;
    }

    /* Empty State */
    [data-bs-theme="dark"] .empty-state .empty-icon {
        color: #4b5563;
    }

    [data-bs-theme="dark"] .empty-state h6 {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .empty-state p {
        color: #6b7280;
    }

    /* Loading Skeleton */
    [data-bs-theme="dark"] .skeleton-card {
        background: linear-gradient(90deg, #1a1d29 0%, #252b3d 50%, #1a1d29 100%);
        background-size: 200% 100%;
    }

    /* Close Button */
    [data-bs-theme="dark"] .btn-white {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border: 1px solid rgba(255, 255, 255, 0.12);
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .btn-white:hover {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.2);
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .btn-white svg {
        color: #e5e7eb;
    }
</style>
